import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-message-separator',
  templateUrl: './message-separator.component.html',
  styleUrls: ['./message-separator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSeparatorComponent {}
